<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class=" py-4  d-md-down-none card-login col-lg-5">
              <b-card-body class="text-center">
                <div class="ml-2">
                  <img  class="navbar-brand-full d-none d-md-block"  src="img/ms_logo.png"
                        alt="MS">
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body class="p-4 col-lg-7">
              <b-card-body>
                <p> Upišite vašu email adresu na koju ćemo poslati uputstvo za promjenu lozinke.</p>
                <b-form @submit.prevent="sendMail" class="mr-2">
                  <b-form-group>
                  <b-input-group >
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-envelope"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      placeholder="Email"
                      type="email"
                      class="form-control"
                      aria-describedby="inputUsernameFeedback"
                      v-model.trim="email">
                    </b-form-input>
                  </b-input-group>
                  <app-validation-description :show="$v.email.$dirty && $v.email.$invalid">
                    <template v-if="!$v.email.email">
                      Unesite ispravan email
                    </template>
                    <template v-else>
                      {{$t('FIELD_MANDATORY')}}
                    </template>
                  </app-validation-description>
                  </b-form-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="danger" class="px-4">POŠALJI
                      </b-button>
                    </b-col>

                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"/>
  </div>
</template>

<script>
import AppSubmit from '@/components/app/AppSubmit'
import { required, email } from 'vuelidate/lib/validators'
import AppValidationDescription from "@/components/app/form/AppValidationDescription";
import loading from 'vue-full-loading'
import {resetPassword} from "@/services/user";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";
import {toast} from "@/shared/plugins/toastr";
import routeNames from "@/router/routeNames";
export default {
  name: "ForgotPassword",
  data(){
    return{
      email:null,
      show: false,
      label: 'Reset...',
      overlay: true,
      message:"",
      showError:false,
      errorMessage:null,
      showMessage:false,
      errorCode:null,
      routeNames
    }
  },
  mixins: [getErrorMessage],
  validations: {
    email: { required, email },
  },
  components: {
    AppSubmit,
    AppValidationDescription,
    loading
  },
  methods:{
    sendMail(){
      this.$v.email.$touch()
      this.show =true;
      resetPassword({email:this.email}).then(()=>{
        toast({
          'title': 'Uspjeh',
          'message': 'provjerite email',
          'type': 'success',
          'timeout': 3000
        })
        this.$router.replace({name: routeNames.RN_LOGIN})
      }).finally(()=> {
        this.show = false;
      })
  }
}
}
</script>

<style scoped>

</style>
